import { ensureArray } from "types";

import { get, IHttpRequestConfig } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";

import { ILegalDocument, legalDocumentType } from "./types";

const API = {
  list: "/api/public/legal/documents",
};

export interface IFetchLegalDocumentsParams {}

export const fetchLegalDocuments = (params: IFetchLegalDocumentsParams = {}, options: IHttpRequestConfig = {}) => {
  const url = compose(API.list, {}, params);
  return get<ILegalDocument[]>(url, options).then(extractDataFromResponse).then(ensureArray(legalDocumentType));
};
